import { render, staticRenderFns } from "./liveTitle.vue?vue&type=template&id=003cdc03&scoped=true&"
import script from "./liveTitle.vue?vue&type=script&lang=ts&"
export * from "./liveTitle.vue?vue&type=script&lang=ts&"
import style0 from "./liveTitle.vue?vue&type=style&index=0&id=003cdc03&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003cdc03",
  null
  
)

export default component.exports